import {
  Check,
  Close,
  Error,
  Information,
  Loading,
  Warning,
} from '@bigin/icons-vue'
import { definePropType } from './props'
import type { Component } from 'vue'

export const iconPropType = definePropType<string | Component>([
  String,
  Object,
  Function,
])

export const CloseComponents = {
  Close,
}

export const TypeComponents = {
  Close,
  Check,
  Information,
  Warning,
  Error,
}

export const TypeComponentsMap = {
  success: Check,
  warning: Warning,
  error: Error,
  info: Information,
}

export const ValidateComponentsMap = {
  validating: Loading,
  success: Check,
  error: Error,
}
